import products from "@/services/products";

const initialState = () => ({
  products: [],

  loadingStatus: 1,
  nextPageApiStatus: 0,
  productPages: 0,

  // 1 - Loading, 2 - Successful, 3 - unsuccesful, 4 - uncaught error
  // getting product categories
  getCategoriesStatus: 0,
  getCategoriesMessage: null,
  categories: [],

  productApiStatus: 0,
  product: {}
});

const state = initialState();

const getters = {
  getAll(state) {
    return state.products;
  },
  getProductPages(state) {
    return state.productPages;
  },
  getLoadingStatus(state) {
    return state.loadingStatus;
  },
  getNextPageApiStatus(state) {
    return state.nextPageApiStatus;
  },
  getFeatured(state) {
    return state.products.slice(0, 3);
  },

  getProduct(state) {
    return state.product
  },
  getProductApiStatus(state) {
    return state.productApiStatus
  },
  
  // getting product categories
  getCategoriesStatus: state => state.getCategoriesStatus,
  getCategoriesMessage: state => state.getCategoriesMessage,
  categories: state => state.categories,

};

const actions = {
  getAll: async ({ commit }) => {
    try {
      commit("setLoadingStatus", 1);

      const response = await products.get();
      commit("setProductPages", response.data.data.totalPages);
      commit("setProducts", response.data.data.products);

      commit("setLoadingStatus", 2);
    } catch (error) {
      commit("setLoadingStatus", 3);
      console.log(error);
    }
  },
  getByPage: async ({ commit }, page=1) => {
    try {
      commit("setNextPageApiStatus", 1);

      const response = await products.getByPage(page);
      commit("setProductPages", response.data.data.totalPages);
      commit("setNextProducts", response.data.data.products);

      commit("setNextPageApiStatus", 2);
    } catch (error) {
      commit("setNextPageApiStatus", 3);
      window.e = error
      console.log(error);
    }
  },
  getProductById: async ({ commit }, id) => {
    try {
      commit('setProductApiStatus', 1)
      
      const response = await products.getProductById(id)
      commit('setProduct', response.data.data)

      commit('setProductApiStatus', 2)
    } catch(e) {
      commit('setProductApiStatus', 3)
      window.e = e
    }
  },

  getCategories: async ({ commit }) => {
    try {
      commit("getCategoriesRequest");
      const response = await products.getCategories();
      commit("getCategoriesSuccess", response.data);
    } catch (error) {
      commit("getCategoriesError", error);
    }
  },
};

const mutations = {
  setProducts(state, products) {
    state.products = products;
  },
  setProductPages(state, pages) {
    state.productPages = pages;
  },
  setNextProducts(state, products) {
    state.products.push(...products)
  },
  setLoadingStatus(state, status) {
    state.loadingStatus = status;
  },
  setNextPageApiStatus(state, status) {
    state.nextPageApiStatus = status;
  },

  setProduct(state, product) {
    state.product = product;
  },
  setProductApiStatus(state, status) {
    state.productApiStatus = status
  },

  // getting product categories
  getCategoriesRequest: state => state.getCategoriesStatus = 1,
  getCategoriesSuccess(state, { message, data }) {
    state.categories = data;
    state.getCategoriesStatus = 2;
    state.getCategoriesMessage = message;
  },
  getCategoriesError(state, error) {
    state.getCategoriesStatus = 3;
    state.getCategoriesMessage = error.response.data.message;
  },

  reset(state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
